<!--
 * @Author: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @Date: 2025-06-16 17:53:28
 * @LastEditors: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @LastEditTime: 2025-06-17 14:29:19
 * @FilePath: \zhucai_user\src\pages\member\child\Material.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="my-container">
    <div class="my-title">我的资料</div>
    <div class="my-content">
      <div class="my-search-box">
        <div class="my-search">
          <i class="el-icon-search" @click="getList"></i>
          <input
            type="text"
            @keyup.enter="getList"
            v-model="getListData.Title"
            placeholder="输入关键词搜索"
          />
        </div>
        <el-button @click="getList" class="search-btn">搜索</el-button>
      </div>
      <el-table v-loading="isLoading" :data="tableData" class="mt20">
        <el-table-column prop="date" label="资料名称">
          <template slot-scope="scope">
            <div class="Material-box">
              <div class="img">
                <img
                  v-if="
                    scope.row.FileExt == '.docx' || scope.row.FileExt == '.doc'
                  "
                  src="@/assets/img/home/29.png"
                  alt=""
                />
                <img
                  v-if="scope.row.FileExt == '.zip'"
                  src="@/assets/img/home/30.png"
                  alt=""
                />
                <img
                  v-if="scope.row.FileExt == '.ppt'"
                  src="@/assets/img/home/31.png"
                  alt=""
                />
                <img
                  v-if="scope.row.FileExt == '.rar'"
                  src="@/assets/img/home/32.png"
                  alt=""
                />
                <img
                  v-if="scope.row.FileExt == '.txt'"
                  src="@/assets/img/home/33.png"
                  alt=""
                />
                <img
                  v-if="scope.row.FileExt == '.7z'"
                  src="@/assets/img/home/34.png"
                  alt=""
                />
                <img
                  v-if="scope.row.FileExt == '.pdf'"
                  src="@/assets/img/home/35.png"
                  alt=""
                />
              </div>
              <div class="flex1">
                <p class="MaterialName">{{ scope.row.MaterialName }}</p>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="ClassifyName"
          label="分类"
          width="180"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="FileExt" label="格式" width="180" align="center">
        </el-table-column>
        <el-table-column
          prop="FileSizeTxt"
          label="大小"
          width="180"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="address" label="" width="180" align="center">
          <template slot-scope="scope">
            <el-button class="table-btn" @click="downUrl(scope.row)">
              下载
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <my-pagination
        :total="total"
        :pageSize="getListData.PageSize"
        v-model="getListData.PageIndex"
      ></my-pagination>
    </div>
  </div>
</template>

<script>
import { GetMyMaterialList } from "@/api/member";
import { MaterialID_GetDownUrl } from "@/api/material";
import myPagination from "@/components/myPagination.vue";
export default {
  components: { myPagination },
  name: "material",
  data() {
    return {
      isLoading: true,
      total: 0,
      tableData: [],
      getListData: {
        Title: "",
        PageIndex: 1,
        PageSize: 10,
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    downUrl(data) {
      MaterialID_GetDownUrl({
        MaterialID: data.MaterialID,
      }).then((res) => {
        if (res.code === 0) {
          var fileUrl = res.data.DownUrl;
          window.open(fileUrl + "?attname=文件名称.docx");
          // window.open(res.data.DownUrl+‘’, "_blank");
        }
      });
    },
    getList() {
      this.isLoading = true;
      const data = this.getListData;
      GetMyMaterialList(data).then((res) => {
        this.isLoading = false;
        this.total = res.count;
        this.tableData = res.data;
      });
    },
  },
  watch: {
    "getListData.PageIndex"() {
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.Material-box {
  display: flex;
  gap: 20px;
  .img {
    width: 23px;
    height: 23px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .MaterialName {
    font-size: 20px;
    color: #333333;
    font-weight: 400;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
</style>
